<template>
  <div class="container">
    <div class="search" style="display:flex">
      <el-form ref="form" style="flex:1" :inline="true" :model="search" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="search.kname" @change="Search" placeholder="模糊搜索名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="search.code" @change="Search" placeholder="货币种类缩写"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" size="small" @click="addcountry">增加</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table border v-bind:data="list">
      <!-- <el-table-column label="序号" type="index" width="50"></el-table-column> -->
      <el-table-column label="记录编码">
        <template v-slot="scope">
          <span>{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column label="名称">
        <template v-slot="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <el-button type="primary" size="small" @click="editcurrency(scope.row)">修改</el-button>
          <el-button type="danger" size="small" @click="deletecurrency(scope.row.code)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      v-model:currentPage="search.page"
      :page-size="search.limit"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination>

    <!-- 新增修改 -->
    <el-dialog :title="title+'币种信息'" v-model="dialogFormVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="记录编号" prop="code" label-width="100px">
          <el-input v-model="form.code" :disabled="edit" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="货币名称" prop="name" label-width="100px">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" v-if="!edit" @click="Validate(addconfirm)">新增</el-button>
          <el-button type="primary" v-if="edit" @click="Validate(editconfirm)">修改</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: '',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      title: '',
      search: {
        page: 1,
        limit: 10,
        kname: '',
        code: '',
      },
      list: [],
      total: 0,
      dialogFormVisible: false,
      form: {
        code: '',
        name: '',
      },
      rules: {
        code: [{ required: true, message: '请输入记录编号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入货币名称', trigger: 'blur' }],
      },
      edit: false
    }
  },
  computed: {},
  watch: {},
  methods: {
    handleCurrentChange(val) {
      this.search.page = val
      this.Search()
    },
    Search (){
      this.api.CurrencyList(this.search).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.data
          this.total = res.data.data.page_info.total
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    addcountry () {
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.form = {
        id: '',
        element_code: '',
        element_content: '',
        language_code: '',
      }
      this.title = '新增'
      this.edit = false
      this.dialogFormVisible = true
    },
    editcurrency(item) {
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = '修改'
      this.edit = true
      this.api.CurrencyDetail(item).then(res => {
         if (res.data.code == 200) {
          this.dialogFormVisible = true
          this.form = res.data.data
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    deletecurrency(item) {
      this.$confirm('是否删除该币种?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除请求
        this.api.CurrencyDelete({
          code: item
        }).then(res => {
          if (res.data.code == 200) {
            this.Search()
            this.$message.success('删除成功')
            return
          }
          this.$message.error('删除失败'+ res.data.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        });
      })
    },
    Validate: function (call) {
      this.$refs['form'].validate(res => {
        if (res && call) {
          call()
        }
      })
    },
    addconfirm () {
      this.update()
    },
    update (){
      this.api.CurrencyUpdate(this.form).then(res => {
        if (res.data.code == 200) {
          this.Search()
          this.$message.success(this.title+'成功')
          this.dialogFormVisible = false
          return
        }
        this.$message.error(this.title+'失败' + res.data.msg)
      })
    },
    editconfirm () {
      this.update()
    },
  },
  filters: {},
  mounted () { },
  created () {
    this.Search()
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
</style>
